var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClosingReport = function SvgClosingReport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-710.000000, -486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-HealthScreening",
    transform: "translate(690.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-Screening-List",
    transform: "translate(0.000000, 353.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,2 C12.3,2 13.4,2.84 13.82,4 L13.82,4 L18,4 C19.1,4 20,4.9 20,6 L20,6 L20.0008756,12.8752824 C19.3807704,12.63299 18.7059159,12.5 18,12.5 C14.9624339,12.5 12.5,14.9624339 12.5,18 C12.5,19.5764335 13.1632304,20.9979613 14.2258813,22.0007734 L4,22 C2.9,22 2,21.1 2,20 L2,20 L2,6 C2,4.9 2.9,4 4,4 L4,4 L8.18,4 C8.6,2.84 9.7,2 11,2 Z M18,14 C20.208,14 22,15.792 22,18 C22,20.208 20.208,22 18,22 C15.792,22 14,20.208 14,18 C14,15.792 15.792,14 18,14 Z M19.1921719,16.2351472 L17.4358914,18.0699747 L16.8070618,17.41388 C16.5083486,17.1022151 16.0235141,17.1022151 15.7240349,17.41388 C15.4253217,17.7263441 15.4253217,18.2322003 15.7240349,18.5438653 L16.8951439,19.7657517 C17.194623,20.0782158 17.6794576,20.0782158 17.9789367,19.7649526 L20.2767307,17.3635342 C20.5746779,17.0510701 20.5746779,16.5452139 20.2751988,16.2335489 C19.9772515,15.9226831 19.4908851,15.9210848 19.1921719,16.2351472 Z M12,16 L6,16 L6,18 L12,18 L12,16 Z M13,12 L6,12 L6,14 L13,14 L13,12 Z M16,8 L6,8 L6,10 L16,10 L16,8 Z M11,4 C10.45,4 10,4.45 10,5 C10,5.55 10.45,6 11,6 C11.55,6 12,5.55 12,5 C12,4.45 11.55,4 11,4 Z",
    id: "Combined-Shape",
    fill: "#F6F7FA"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClosingReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closing-report.589f4fcc.svg";
export { ForwardRef as ReactComponent };